export const mediaInquiryFormDict = {
  en: {
    mediaInquiry: 'Media inquiry',
    subjectList: [
      'We write about investments to obtain a second citizenship',
      'We would like to interview one of the managers',
      'We would like to receive presentations on programs for obtaining second citizenship',
      'Another question',
    ],
    submit: 'Send request',
    thanks: 'Thank you',
    weReceivedMessage:
      'We have received your message and will contact you within 2 hours. If you would like a faster response, please contact us:',
    contactPhone: '+43 (670) 308‑21‑75',
    messageLabel:
      'If you have any questions, type them here and we will prepare the answers',
    sf_record_type_code: '012580000005hteAAA',
    fr_form_id: 'imin-128',
  },
  de: {
    mediaInquiry: 'Presseanfragen',
    subjectList: [
      'Wir schreiben über Investitionen zur Erlangung einer zweiten Staatsbürgerschaft',
      'Wir würden gerne einen der Manager interviewen',
      'Wir würden gerne Vorträge zu Programmen zur Erlangung der zweiten Staatsbürgerschaft erhalten',
      'Eine andere Frage',
    ],
    submit: 'Einreichen',
    thanks: 'Danke',
    weReceivedMessage:
      'Wir haben Ihre Nachricht erhalten und werden uns innerhalb von 2 Stunden bei Ihnen melden. Wenn Sie eine schnellere Antwort wünschen, kontaktieren Sie uns bitte:',
    contactPhone: '',
    messageLabel:
      'Wenn Sie Fragen haben, geben Sie diese hier ein und wir bereiten die Antworten vor',
    sf_record_type_code: '',
    fr_form_id: '',
  },
  ru: {
    mediaInquiry: 'Медиа-запрос',
    subjectList: [
      'Мы пишем об инвестициях для получения второго гражданства',
      'Мы хотели бы провести интервью с одним из руководителей',
      'Мы бы хотели получить презентации программ получения второго гражданства',
      'Другой вопрос',
    ],
    submit: 'Отправить',
    thanks: 'Спасибо',
    weReceivedMessage:
      'Мы получили сообщение и свяжемся с вами в течение 2 часов. Если вы хотите получить ответ быстрее, свяжитесь с нами:',
    contactPhone: '+43 (650) 540‑49‑79',
    messageLabel: 'Если у вас есть вопрос, задайте его, и мы подготовим ответ',
    sf_record_type_code: '0124H000000kMjGQAU',
    fr_form_id: 'imin-129',
  },
  tr: {
    mediaInquiry: 'Medya talebi',
    subjectList: [
      'İkinci vatandaşlık almak için yatırımlar hakkında yazıyoruz',
      'Yöneticilerden biriyle röportaj yapmak istiyoruz',
      'İkinci vatandaşlık edinme programları hakkında sunum almak istiyoruz',
      'Başka bir soru',
    ],
    submit: 'Talep gönder',
    thanks: 'Teşekkür ederiz',
    weReceivedMessage:
      'Mesajınızı aldık ve 2 saat içinde sizinle iletişime geçeceğiz. Daha hızlı bir yanıt almak isterseniz, lütfen bizimle iletişime geçin:',
    contactPhone: '',
    messageLabel:
      'Herhangi bir sorunuz varsa, burada yazın ve biz de yanıtları hazırlayalım',
    sf_record_type_code: '',
    fr_form_id: '',
  },
  es: {
    mediaInquiry: 'Consulta de medios',
    subjectList: [
      'Escribimos sobre inversiones para obtener una segunda ciudadanía',
      'Nos gustaría entrevistar a uno de los gerentes',
      'Nos gustaría recibir presentaciones sobre programas para obtener una segunda ciudadanía',
      'Otra pregunta',
    ],
    submit: 'Enviar solicitud',
    thanks: 'Gracias',
    weReceivedMessage:
      'Hemos recibido su mensaje y nos pondremos en contacto con usted dentro de 2 horas. Si desea una respuesta más rápida, por favor contáctenos:',
    contactPhone: '+43 (670) 308‑21‑75',
    messageLabel:
      'Si tiene alguna pregunta, escríbala aquí y prepararemos las respuestas',
    sf_record_type_code: '',
    fr_form_id: 'imin-128',
  },
};
